import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import NavbarPC from "../../../components/navbar-pc";
import NavbarMobile from "../../../components/navbar-mobile/navbar-mobile";

const MainMenu = () => {
    return (
        <div>
            <NavbarMobile />
            <NavbarPC />

            <Outlet />
        </div>
    );
};

export default MainMenu;
